export default {
  region: 'us-east-1',
  cognitoUserPoolId: 'us-east-1_c9naOBR1X',
  cognitoUserPoolWebClientId: 'fp7qlp7l87qn8069kt4500dp4',
  cognitoIdentityPoolId: 'us-east-1:60960da7-766e-46a4-8914-96fc3c3d03d7',
  cognitoDomain: 'pv-mme-dynamic-ads-kauranmm.auth.us-east-1.amazoncognito.com',
  redirectSignIn: 'https://kauranmm.personal.dynamic-ads.video.amazon.dev/auth-callback',
  redirectSignOut: 'https://kauranmm.personal.dynamic-ads.video.amazon.dev/',
  apiServerBaseUrl: 'https://api.kauranmm.personal.dynamic-ads.video.amazon.dev',
  stage: 'personal',
  benderApiServerBaseUrl: 'https://api.beta.bender.dynamic-ads.video.amazon.dev',
  fryApiServerBaseUrl: 'https://api.beta.fry.dynamic-ads.video.amazon.dev',
  loggerBaseUrl: 'https://logger.kauranmm.personal.dynamic-ads.video.amazon.dev/{proxy+}',
  monitoringBaseUrl: 'https://monitoring.kauranmm.personal.dynamic-ads.video.amazon.dev/{proxy+}',
  featureFlags: 'enableReportingDashboard,enableBlocklist,enableAbTesting,enableSpotlightLal,enablePublisherConfigs,enablePublisherConfigCampaignForm',
  spotlightApiGatewayBaseUrl: 'https://beta.spotlight.video.amazon.dev',
  productsBucketName: 'usamazon-test-products3sta-products3bucketd2b91f8d-wiuyon9anyoo',
  mediaBucketName: 'leela-media-160928622799-us-east-1-personal',
  agentCoreWsUrl: 'wss://bedrock-agentcore.us-east-1.amazonaws.com/runtimes/arn:aws:bedrock-agentcore:us-east-1:160928622799:runtime/leela_agent_orchestrator_personal-v2RnvSBnpv/ws',
};
